/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Round_Crisp_Octopus_DrumInputs */

const fr_round_crisp_octopus_drum = /** @type {(inputs: Round_Crisp_Octopus_DrumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**

* @param {Round_Crisp_Octopus_DrumInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const round_crisp_octopus_drum = /** @type {((inputs?: Round_Crisp_Octopus_DrumInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Round_Crisp_Octopus_DrumInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_round_crisp_octopus_drum(inputs)
});